import { activeGameId } from "../../../util/selectors";
import { getSafe } from "../../../util/storeHelper";
import { truthy } from "../../../util/util";
function createCategoryDetailPath(categories, category, categoryPath, hideTopLevel, visited) {
    if (!truthy(categories[category])) {
        return null;
    }
    const isTopLevel = categories[category].parentCategory === undefined;
    // Only hide the top-level category name if it's not the leaf category
    // (i.e., there are child categories in the path below it)
    if (!hideTopLevel || !isTopLevel || categoryPath === "") {
        categoryPath =
            categoryPath === ""
                ? categories[category].name
                : categories[category].name + " --> " + categoryPath;
    }
    visited.add(category);
    if (categories[category].parentCategory !== undefined &&
        !visited.has(categories[category].parentCategory)) {
        return createCategoryDetailPath(categories, categories[category].parentCategory, categoryPath, hideTopLevel, visited);
    }
    else {
        return categoryPath;
    }
}
/**
 * retrieve the Category from the Store returning the full category path.
 *
 * @param {number} category
 * @param {Redux.Store<any>} store
 */
export function resolveCategoryPath(category, state) {
    if (!truthy(category)) {
        return null;
    }
    // Handle cases where category might be an array converted to string (e.g., "95,1704")
    // or a number - normalize to the first/primary category ID as a string
    let categoryId;
    if (typeof category === "number") {
        categoryId = category.toString();
    }
    else {
        categoryId = category.toString().split(",")[0];
    }
    let completePath = "";
    const gameId = activeGameId(state);
    const categories = getSafe(state, ["persistent", "categories", gameId], {});
    const hideTopLevel = getSafe(state, ["settings", "interface", "hideTopLevelCategory"], false);
    if (categories[categoryId] !== undefined) {
        completePath = createCategoryDetailPath(categories, categoryId, "", hideTopLevel, new Set());
    }
    return completePath;
}
export function resolveCategoryId(name, state) {
    const gameId = activeGameId(state);
    const categories = state.persistent.categories[gameId];
    const key = Object.keys(categories ?? {}).find((iter) => categories[iter].name === name);
    if (key !== undefined) {
        return parseInt(key, 10);
    }
    else {
        return undefined;
    }
}
/**
 * retrieve the Category from the Store
 *
 * @param {number} category
 * @param {Redux.Store<any>} store
 */
export function resolveCategoryName(category, state) {
    if (!truthy(category)) {
        return "";
    }
    // Handle cases where category might be an array converted to string (e.g., "95,1704")
    // or a number - normalize to the first/primary category ID as a string
    let categoryId;
    if (typeof category === "number") {
        categoryId = category.toString();
    }
    else {
        categoryId = category.toString().split(",")[0];
    }
    const gameId = activeGameId(state);
    return getSafe(state, ["persistent", "categories", gameId, categoryId, "name"], "");
}
